import { Component } from '@angular/core';
import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { BaseProductPickerListViewComponent } from './base-product-picker-list-view.component';

@Component({
  selector: 'boi-product-picker-list-view',
  templateUrl: './product-picker-list-view.component.html',
  styleUrls: ['./product-picker-list-view.component.scss']
})
export class ProductPickerListViewComponent extends BaseProductPickerListViewComponent {
  protected getSortOptionKey(): string {
    return ReferenceDataOptionLists.ProductPickerSortOptions;
  }
}
